import CartApiService from '@package/core/src/shoppingCart/CartApiService';
import CartInteractor from '@package/core/src/shoppingCart/CartInteractor';

import { apiClient, cookieStorage, listrakAnalytic } from '../services';
import { useStrictQuery } from '../useCustomQuery';

import { PRODUCT_ADDONS_DATA_QUERY_KEY } from './types';

const cartService = new CartApiService(apiClient, cookieStorage, listrakAnalytic);
const cartInteractor = new CartInteractor(cartService);

export default function useProductAddons(productSku: string, relatedProductsAvailable: boolean) {
  const { data: productAddons, isFetched } = useStrictQuery([PRODUCT_ADDONS_DATA_QUERY_KEY, productSku], async () => {
    if (relatedProductsAvailable) {
      const { data } = await cartInteractor.getProductAddons({ productSku });

      return data;
    }
  });

  return { isFetched, productAddons };
}
